import React from 'react'
import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { BasePublisherBaseField } from '../../base-publisher-field/base-publisher-base-field'
import { useFormField } from '../hooks/use-form-field'

interface FormBaseFieldSubentityProps {
  fieldSubentity: FormFieldInterface
}

export const FormBaseFieldSubentity = ({
  fieldSubentity,
}: FormBaseFieldSubentityProps) => {
  const { value, onChange, errors } = useFormField({
    fieldSubentity,
  })
  return (
    <BasePublisherBaseField
      entity={fieldSubentity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
